'use strict';

import './style.css';
import template from './template.html';
import MobileDetect from 'mobile-detect';

var md = new MobileDetect(window.navigator.userAgent);


export default function($interpolate, $sce) {
	'ngInject';

	return {
		link: postLink,
		template: template,
		scope: {
			$user: '<user',
		},
	};

	function postLink(scope, element, attrs) {
		var nameTemplate = element.attr('name-template');
		if (!nameTemplate) {
			nameTemplate = '{{ $user.first_name }} {{ $user.last_name }}';
		}
		scope.displayName = $interpolate(nameTemplate)(scope);
		scope.mobile = md.phone();
		scope.callUrl = $sce.trustAsUrl(`tel:${scope.$user.phone_number}`);
		scope.textUrl = $sce.trustAsUrl(`sms://${scope.$user.phone_number}`);
	}
}
